<template>
    <div>
        <limitless-page-header title="Momsrapport" sub-title="Inlösen"></limitless-page-header>

        <div class="content">
            <div class="card" style="max-width: 700px;">
                <div class="table-responsive mb-0">
                    <table class="table table-xs">
                        <thead>
                            <tr>
                                <th>Order</th>
                                <th>Kortserie</th>
                                <th>Kortnummer</th>
                                <th class="text-right">Pris</th>
                                <th class="text-right">År</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, r_index) in tabledata" :key="'r-' + r_index">
                                <td>{{ row.OrderID }}</td>
                                <td>{{ row.CardSeriesID }}: {{ row.SeriesName }}</td>
                                <td><router-link :to="{ name: 'prodorders.list', query: { search: row.CardNo } }">{{ row.CardNo }}</router-link></td>
                                <td class="text-right">{{ formatCurrency(row.total_price) }}</td>
                                <td class="text-right">{{ row.year }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import { formatCurrency, formatNumber } from '@services/Helpers';
import apiClient from '@services/ApiClient';

export default {
    components: {
        LimitlessPageHeader,
    },
    props: {
        cardSerieId: {
            type: Number,
            required: true,
        },
        period: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        loading: true,
        tabledata: null,
    }),
    mounted() {
        this.getData();
    },
    methods: {
        formatCurrency,
        formatNumber,
        getData() {
            this.loading = true;
            apiClient.get('/vue/economy/report/vatredeemed/cards/' + this.cardSerieId + '/' + this.period)
                .then((response) => {
                    this.tabledata = response.data;
                })
                .finally(() => {
                    this.loading = true;
                });
        },
    },
    computed: {
        old_system_url() {
            return window.config.app.old_system_url;
        },
    },
};

</script>
